import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { formatInTimeZone } from 'date-fns-tz';
import { Subscription } from 'rxjs';
import { image } from 'src/app/image.const';
import { MessageService } from 'src/app/rest_services/msMessageServices/message.service';
import { TeamService } from 'src/app/rest_services/team.service';

@Component({
  selector: 'app-messagerie',
  templateUrl: './messagerie.component.html',
  styleUrls: ['./messagerie.component.css']
})
export class MessagerieComponent implements OnInit {

  searchQuery: string = '';
  newMessageText: string = '';
  selectedFile: any;

  toggled : boolean = false;
  loading_msg: boolean = true;
  visitMessages: { message: string; sender: 'left' | 'right'; date: string; status : string ;  seen_at : string, visit_uuid: string }[] = [];
  customerMessages: { message: string; sender: 'left' | 'right'; date: string; status : string ;  seen_at : string, customer_uuid: string }[] = [];
  messages: { message: string | any; sender: 'left' | 'right'; date: string; status: string; seen_at: string , image?:any}[] = [];

  friendDrawerItems :any;
  
  activeMemberIndex: number = -1;
  selectedMember: any;
  mobile: boolean = false;
  fullname:any ='';
  id:any;

  constructor(
    private teamServiceservice : TeamService,
    private messageService: MessageService,
    private route : ActivatedRoute,
    public sanitizer: DomSanitizer,
    private changeDetectorRef : ChangeDetectorRef
  ) { }

  token : any;
  connectedUserId : any;


  imgWrap:any = "";
  imgArray:any[] = [];
  picturesVisit:any[]=[];

  ngOnInit(): void {
    if (window.screen.width <= 768) { 
      this.mobile = true;
    }else {
      this.mobile = false;
    }
    this.id= this.route.snapshot.paramMap.get('mb');
    var fr= window.location.href.split( 'from');
    if(fr[1]!=undefined && fr.length>0){
      var from = fr[1].split(';')[0];
      if(from!="all"){
        this.teamServiceservice.getTeam('members');
        this.teamServiceservice.teamSubject.subscribe(
          ( data: any ) => {
            if(data.code =="d9cc2e7dc2cf71242be86ab1ad241752"){
              this.friendDrawerItems = data.team;
              this.friendDrawerItems.forEach((member : any) => {
                if (member.fullname == this.fullname) {
                  this.friendDrawerItems.splice(this.friendDrawerItems.indexOf(member), 1);
                }
              });
              this.teamLoading = false;              
              var member = this.friendDrawerItems.find((member: any) => member.uuid == this.id);              
              this.setSelectedMember(member, this.friendDrawerItems.indexOf(member));
            }
          },
        )  
      }
      else{
        this.Team();      
      }
    }
    
    if(localStorage.getItem("role")!=undefined) {
      this.token =localStorage.getItem("token");
      this.fullname =localStorage.getItem("fullname");
    }else if(sessionStorage.getItem("role")!=undefined){
      this.fullname =sessionStorage.getItem("fullname");
      this.token =sessionStorage.getItem("token");
    }
    let decodedJWT = JSON.parse(window.atob(this.token.split('.')[1]));
    this.connectedUserId = decodedJWT.userId;
    $( '.chatbox' ).hide();
    $(document).ready(function() {
      var chatPanel = $('.chat-panel');
      chatPanel.scrollTop(chatPanel[0].scrollHeight);
    });

    const glob = this;
    // $('body').on('click', ".upload__img-close", function (e: any) {
      
    //   var file = $(this).parent().data("file") ?? $(this).parent().parent().data("file") ?? $(this).closest('.upload__img-close').siblings('embed').data("file");
        
    //     for (var i = 0; i < glob.imgArray.length; i++) {
    //       if (glob.imgArray[i].name === file) {
    //           glob.imgArray.splice(i, 1);
    //           glob.picturesVisit.splice(i, 1);
    //           break;
    //       }
    //   }
    //   const fileElements = document.querySelectorAll(`.upload__img-wrap [data-file="${file}"]`);
    //   fileElements.forEach(element => element.parentElement?.remove());
    // });

    $('body').on('click', ".upload__img-close", function (e: any) { 
        const imgWrap = document.querySelector('.upload__img-wrap') as HTMLElement;
        if (imgWrap) {
            const fileElement = e.target.closest('.upload__img-box') || e.target.closest('.upload__pdf-box');
            if (fileElement) {                
              const fileNameElement = fileElement.getAttribute('data-file')?? fileElement.querySelector('[data-file]').getAttribute('data-file');              
                for (let i = 0; i < glob.imgArray.length; i++) {
                    if (glob.imgArray[i].name === fileNameElement) {
                        glob.imgArray.splice(i, 1);
                        glob.picturesVisit.splice(i, 1);
                        break;
                    }
                fileElement.remove();
              }
            }
        }
    });
  }

  handleSelection(event: any) {
    this.newMessageText += event.char;
  }

  teamLoading: boolean = true;
  Team(){
    this.teamServiceservice.getTeam('members');
    this.teamServiceservice.teamSubject.subscribe(
      ( data: any ) => {
        if(data.code =="d9cc2e7dc2cf71242be86ab1ad241752"){
          this.friendDrawerItems = data.team;
          this.friendDrawerItems.forEach((member : any) => {
            if (member.fullname == this.fullname) {
              this.friendDrawerItems.splice(this.friendDrawerItems.indexOf(member), 1);
            }
          });
          this.getLastMessage(this.friendDrawerItems);
          this.teamLoading = false;
        }
        setTimeout(() => {
          $('.friend-drawer--onhover').on('click', function() {
            $('.chat-bubble').hide('slow').show('slow');
            $('.no-chat-selected').hide();
            $('.chatbox').show('slow');
           setTimeout(() => {
            var chatPanel = $('.chat-panel');
            chatPanel.animate({
              scrollTop: chatPanel[0].scrollHeight
            }, 'slow');
           }, 2000);
          });
        }, 1000);
      },
    )  
  }
  formatUtcTime(dateStr: string): string {
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return '';
    
    const hours = String(date.getUTCHours()).padStart(2, '0');
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`;
  }
  getLastMessage(members: any) {
    members.forEach((member : any) => {
      const memberId = member.uuid;
      this.messageService.getLastMessage(memberId).subscribe(
        (userData: any) => {
          if (userData) {
            member.message = userData.lastMessage?.message;
            member.unread_count = userData.lastMessage?.unread_count;
            member.date = userData.lastMessage?.sent_at;
            member.sent_by = userData.lastMessage?.sent_by;
            member.is_seen = userData.lastMessage?.is_seen;
            member.containsPj = userData.lastMessage?.containsPj;
            member.fileType = userData.lastMessage?.fileType;
          }
        },
        (error: any) => {
          console.error('Error fetching user data:', error);
        }
        
      );
    });
  }
  sending: boolean = false;

  isCombinedMessage(message: any): boolean {
    return message.message != '' && message.image != '';
  }
  openModal(file: any) {
    this.selectedFile = file;
  }

messagesToSend : any = [];

  sendMessage() {
    if (this.newMessageText.trim() !== '' || this.imgArray.length > 0) {
        this.sending = true;
        const currentTime = this.getCurrentTime();
        const textMessage = this.newMessageText.trim();
        const important = $("#roundedChk2").is(':checked');

        // Create a message object for text and image together
        if (textMessage !== '' && this.imgArray.length === 1) {
            const message: any = {
                message: textMessage,
                image: { base64: this.picturesVisit[0].base64, file: this.picturesVisit[0].file },
                sender: 'right',
                date: currentTime,
                status: 'unread',
                seen_at: ''
            };
            this.messagesToSend.push(message);
        } else {
            // Create a message object for text
            if (textMessage !== '') {
                const textMessageObj: any = {
                    message: textMessage,
                    sender: 'right',
                    date: currentTime,
                    status: 'unread',
                    seen_at: ''
                };
                this.messagesToSend.push(textMessageObj);
            }

            // Create a message object for each image
            for (const img of this.picturesVisit) {
                const imgMessage: any = {
                    message: '',
                    image: { base64: img.base64, file: img.file },
                    sender: 'right',
                    date: currentTime,
                    status: 'unread',
                    seen_at: ''
                };
                this.messagesToSend.push(imgMessage);
            }
        }


        const sendMessages = () => {
            for (const message of this.messagesToSend) {
                sendToService(message);
                this.messages.push(message);
                var chatPanel = $('.chat-panel');
                chatPanel.scrollTop(chatPanel[0].scrollHeight);
            }
            this.sending = false;
            this.newMessageText = '';
            this.messagesToSend = [];
            this.imgArray = []; // Clear the image array after sending
            this.picturesVisit = []; // Clear the image array after sending
            const imgWrap = document.querySelector('.upload__img-wrap') as HTMLElement;
            if (imgWrap) {
                imgWrap.innerHTML = '';
                imgWrap.style.display = 'none';
            }
        };
        const sendToService = (message: any) => {
          const requestBody = {
              sentTo: this.selectedMember.uuid,
              message: message.message,
              date: message.date,
              important: important,
              attachmentName: message.image?.file.name || null,
              attachmentData: message.image?.base64 || null,
              attachmentType: message.image?.file.type || null,
              attachmentSize: message.image?.file.size || null
          };

          this.messageService.sendMessage(requestBody);
          this.messageService.sendMessageSubject.subscribe(
            ( data: any ) => {
              // this.sending = false;
              if (data.status === "200") {
              }
            }
          )
          
      };
        sendMessages();
    }
  }


  formatFileName(fileName: string): string[] {
    const maxLength = 32;
    const parts = [];

    for (let i = 0; i < fileName.length; i += maxLength) {
      parts.push(fileName.substring(i, i + maxLength));
    }

    return parts;
  }
  
  addPic(event: any) {
    var imgWrap = document.querySelector('.upload__img-wrap')as HTMLElement;
    if (imgWrap) {
      imgWrap.style.display = 'flex';
    }else{
      var container = document.querySelector('.chat-panel')as HTMLElement;
      imgWrap = document.createElement('div');
      imgWrap.classList.add('upload__img-wrap');
      container.appendChild(imgWrap);
    }
    const files = event.target.files;
    const glob = this;

    for (let i = 0; i < files.length; i++) {
        const file = files[i];
        this.imgArray.push(file);
        if (!this.isValidFileType(file)) continue; // Check if file type is valid
        const reader = new FileReader();
        const mobile = this.mobile;
        reader.onload = function(e) {     
          const fileData = {
            file: file, // Store the file information
            base64: e.target?.result // Store the base64 data
          };
          if (glob.picturesVisit == undefined || glob.picturesVisit == null) {
              glob.picturesVisit = [];
          }
          glob.picturesVisit?.push(fileData);
          // glob.picturesVisit?.push(e.target?.result);
          if (glob.isFileImage(file)) {
              const imgBox = "<div class='upload__img-box' style= 'margin-bottom: 15px;'><div style='background-image: url(" + e.target?.result + ")' data-number='" + $(".upload__img-close").length + "' data-file='" + file.name + "' data-type='image' class='img-bg'><div class='upload__img-close'></div></div></div>";
              if (imgWrap) {
                  imgWrap.innerHTML += imgBox;
              }
          } else if (file.type === 'application/pdf' && !mobile) {
            const fileContainer = document.createElement('div');
            fileContainer.classList.add('upload__pdf-box');
            fileContainer.style.display = 'flex';
            const embedElement = document.createElement('embed');
            embedElement.src = e.target?.result as string;
            embedElement.type = 'application/pdf';
            embedElement.width = '180px';
            embedElement.height = '180px'; 
            fileContainer.appendChild(embedElement);
            const deleteButton = document.createElement('div');
            deleteButton.classList.add('upload__img-close');
            deleteButton.style.position= 'relative';
            deleteButton.style.right= '50px';
            fileContainer.append(deleteButton);
            imgWrap?.appendChild(fileContainer);
          }else if (file.type === 'application/pdf' && mobile) {
            const fileDetails = `<div class="file-details upload__pdf-box"> 
                                      ${file.name}<br> 
                                      ${Math.ceil(file.size / 1024 / 1024)} MB, Document PDF
                                    </div>`;
              const fileContainer = document.createElement('div');
              fileContainer.innerHTML = fileDetails;
              fileContainer.style.margin = 'auto 2px';
              fileContainer.style.textAlign = 'center';
              fileContainer.style.background = 'white';
              fileContainer.style.color = '#116e67';
              fileContainer.style.padding = '10px';
              fileContainer.style.border = '6px solid beige';
              fileContainer.style.borderRadius = '20px';
              fileContainer.style.display = 'flex';
              fileContainer.setAttribute('data-file', file.name);
              fileContainer.setAttribute('data-type', 'pdf');
              const deleteButton = document.createElement('div');
              deleteButton.classList.add('upload__img-close');
              deleteButton.style.position = 'initial';
              fileContainer.append(deleteButton);
              imgWrap?.appendChild(fileContainer);
        } else if (file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
              const fileDetails = `<div class="file-details"> 
                                      ${file.name}<br> 
                                      ${Math.ceil(file.size / 1024 / 1024)} MB, Document Microsoft Word 
                                    </div>`;
              const fileContainer = document.createElement('div');
              fileContainer.classList.add('upload__pdf-box');
              fileContainer.innerHTML = fileDetails;
              fileContainer.style.margin = 'auto 2px';
              fileContainer.style.textAlign = 'center';
              fileContainer.style.background = 'white';
              fileContainer.style.color = '#116e67';
              fileContainer.style.padding = '10px';
              fileContainer.style.border = '6px solid beige';
              fileContainer.style.borderRadius = '20px';
              fileContainer.style.display = 'flex';
              fileContainer.setAttribute('data-file', file.name);
              fileContainer.setAttribute('data-type', 'docx');
              const deleteButton = document.createElement('div');
              deleteButton.classList.add('upload__img-close');
              deleteButton.style.position = 'initial';
              fileContainer.append(deleteButton);
              imgWrap?.appendChild(fileContainer);
            } else {
                // Handle non-image, non-PDF, non-DOCX file display or processing
                // For example, create a link to download the file
                const fileLink = document.createElement('a');
                fileLink.href = e.target?.result as string;
                fileLink.download = file.name;
                fileLink.innerText = file.name;
                imgWrap?.appendChild(fileLink);
            }

          var chatPanel = $('.chat-panel');
            chatPanel.animate({
              scrollTop: chatPanel[0].scrollHeight
            }, 'slow');

        };

        reader.readAsDataURL(file);
    }
  }
  removeFile(index: number): void {
    if (index >= 0 && index < this.picturesVisit.length) {
        this.picturesVisit.splice(index, 1);
        this.imgArray.splice(index, 1);  // Assuming imgArray stores the File objects in sync
    }
  }


  isValidFileType(file: any): boolean {
    const allowedTypes = ['image/png', 'image/jpeg', 'application/pdf', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document']; // Add more types as needed
    return allowedTypes.includes(file.type);
  }
  getDownloadLink(file: any): string {
    const base64Data = file.base64;
    const blob = new Blob([base64Data], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
    return URL.createObjectURL(blob);
  }

  downloadFile(file :any) {
    const base64Data = file.base64;
    const fileName = file.file.name;
    
    const blob = this.base64ToBlob(base64Data);
    const blobUrl = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = fileName;
    link.click();

    // Clean up the URL object after the download
    URL.revokeObjectURL(blobUrl);
  }
  base64ToBlob(base64Data: string): Blob {
    const byteCharacters = atob(base64Data.split(',')[1]);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
  }

  isFileImage(file: any): boolean {
      return file.type.includes('image');
  }

  isFilePDF(file: any): boolean {
    return file.type === 'application/pdf';
  }

  isFileWordDocument(file: File): boolean {
    return file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
  }
  getFileSizeInMB(file: File): number {
    // Convert file size from bytes to megabytes and round it up
    return Math.ceil(file.size / (1024 * 1024));
  }

  getCurrentTime(): string {
    const currentDate: Date = new Date();
    const year: string = currentDate.getFullYear().toString();
    const month: string = (currentDate.getMonth() + 1 < 10 ? '0' : '') + (currentDate.getMonth() + 1).toString(); // Month is zero-based
    const day: string = (currentDate.getDate() < 10 ? '0' : '') + currentDate.getDate().toString();
    const hours: string = (currentDate.getHours() < 10 ? '0' : '') + currentDate.getHours().toString();
    const minutes: string = (currentDate.getMinutes() < 10 ? '0' : '') + currentDate.getMinutes().toString();
    const seconds: string = (currentDate.getSeconds() < 10 ? '0' : '') + currentDate.getSeconds().toString();
    return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
  }
  
  filterMessages(messages: any[]): any[] {
    if (!this.searchQuery.trim()) {
      return messages;
    }
    const regex = new RegExp(this.searchQuery.trim(), 'gi');
    return messages.filter(message => regex.test(message.message));
  }
   
  setActiveMember(index: number) {
    this.activeMemberIndex = index;
  }

  setSelectedMember(member: any, i :number) {
    this.loading_msg = true;
    this.sending = false;
    this.newMessageText = '';
        this.imgArray = []; // Clear the image array after sending
        this.picturesVisit = []; // Clear the image array after sending
        const imgWrap = document.querySelector('.upload__img-wrap') as HTMLElement;
        if (imgWrap) {
            imgWrap.innerHTML = '';
            imgWrap.style.display = 'none';
        }
    this.messages = [];
    this.visitMessages = [];
    this.customerMessages = [];
    this.selectedMember = member;
    this.toggleCollapseAndSetMember(i);    
    this.messageService.getMessages(this.selectedMember.uuid);
    this.messageService.getMessagesSubject.subscribe(
      (data: any) => {        
        if (data.status === "200") {
          const sortedMessages = data.messageEnvelop.sort((a: any, b: any) => {
            return new Date(a.date).getTime() - new Date(b.date).getTime();
          });          
          sortedMessages.forEach((message: any) => {
            if (message.sent_to === this.selectedMember.uuid && message.sent_by === this.connectedUserId) {
              if(message.source == "visit"){
                this.visitMessages.push({ message: message.message, sender: 'right', date: message.date, status :message.status, seen_at : message.seen_at, visit_uuid : message.visit_uuid });
              }else if(message.source == "customer"){
                this.customerMessages.push({ message: message.message, sender: 'right', date: message.date, status :message.status, seen_at : message.seen_at, customer_uuid : message.customer_uuid });
              }else{                
                const base64Data = message.attachmentData || null;
                if(base64Data){
                  const file : any ={
                    name : message.attachmentName,
                    type : message.attachmentType,
                    size : message.attachmentSize
                  }
                  const image = { base64: base64Data, file: file };
                  this.messages.push({ message: message.message, sender: 'right', date: message.date, status :message.status, seen_at : message.seen_at, image: image });
                }
                else{
                  this.messages.push({ message: message.message, sender: 'right', date: message.date, status :message.status, seen_at : message.seen_at });
                }
              }
            } else if (message.sent_by === this.selectedMember.uuid && message.sent_to === this.connectedUserId) {              
              if(message.source == "visit"){
                this.visitMessages.push({ message: message.message, sender: 'left', date: message.date, status :message.status, seen_at : message.seen_at, visit_uuid : message.visit_uuid });
              } else if(message.source == "customer"){
                this.customerMessages.push({ message: message.message, sender: 'left', date: message.date, status :message.status, seen_at : message.seen_at , customer_uuid : message.customer_uuid});
              } else{                
                const base64Data = message.attachmentData || null;
                if(base64Data){
                  const file : any ={
                    name : message.attachmentName,
                    type : message.attachmentType,
                    size : message.attachmentSize
                  }
                  const image = { base64: base64Data, file: file };
                  this.messages.push({ message: message.message, sender: 'left', date: message.date, status :message.status, seen_at : message.seen_at, image: image });
                }
                else{
                  this.messages.push({ message: message.message, sender: 'left', date: message.date, status :message.status, seen_at : message.seen_at });
                }
              }
            }
          });
          $('.chat-bubble').hide('slow').show('slow');
          $('.no-chat-selected').hide();
          $('.chatbox').show('slow');
          this.loading_msg = false;
          setTimeout(() => {
            var chatPanel = $('.chat-panel');
            chatPanel.animate({
              scrollTop: chatPanel[0].scrollHeight
            }, 'slow');
          }, 2000);
        }
      }
    );
  }  

  toggleCollapseAndSetMember(index: number) {
    const friendListCollapse = document.getElementById('friendList');    
    if (friendListCollapse?.classList.contains('show') && this.mobile) {
        friendListCollapse.classList.remove('show');
    }
    this.setActiveMember(index);
  }

  getMessageDay(messageTime: string, index: number): string {
    const today = new Date();
    const parts = messageTime.split('-'); // Assuming format is "YYYY-MM-DD"
    const messageDate = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));

    if (this.isSameDay(today, messageDate) || messageDate.toDateString() === today.toDateString()) {
        return 'Aujourd\'hui';
    } else if (this.isYesterday(today, messageDate)) {
        return 'Hier';
    } else {
        return messageDate.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' })!;
    }
  }

  isSameDay(date1: Date, date2: Date): boolean {
      return date1.getFullYear() === date2.getFullYear() &&
          date1.getMonth() === date2.getMonth() &&
          date1.getDate() === date2.getDate();
  }

  isYesterday(date1: Date, date2: Date): boolean {
      const yesterday = new Date(date1);
      yesterday.setDate(date1.getDate() - 1);
      return this.isSameDay(yesterday, date2);
  }

}